import App from '@/app';
import globalStylesUrl from '@/global.css?url';
import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HeadContent, Scripts, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { type FC } from 'react';

const loadingCSS = `
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.circular {
  position: relative;
  width: 100px;
  height: 100px;
  animation: rotate 0.5s linear infinite;
}

.path {
  animation: dash 1.5s ease-in-out infinite;
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
`;

const RootComponent: FC = () => {
  const { queryClient } = Route.useRouteContext();

  return (
    <html>
      <head>
        <HeadContent />
      </head>
      <body>
        <noscript>You need to enable JavaScript to run this app.</noscript>
        <App queryClient={queryClient} />
        <TanStackRouterDevtools position="bottom-right" />
        <ReactQueryDevtools buttonPosition="bottom-left" />
        <Scripts />
      </body>
    </html>
  );
};

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'theme-color', content: '#000000' },
      { name: 'description', content: 'Community' },
    ],
    links: [
      { rel: 'apple-touch-icon', href: '/favicon-32x32.png' },
      { rel: 'manifest', href: '/manifest.json' },
      {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
      },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
      },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=block',
      },
      {
        rel: 'stylesheet',
        href: globalStylesUrl,
      },
    ],
    title: 'Community',
  }),
  component: RootComponent,
  pendingComponent: () => (
    <>
      <style>{loadingCSS}</style>
      <div id="root">
        <div className="loading-container">
          <svg className="circular">
            <circle
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeWidth="7"
              stroke="#0f6eff"
              opacity="0.25"
              strokeMiterlimit="10"
            />
            <circle
              className="path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeWidth="7"
              stroke="#0f6eff"
              strokeMiterlimit="10"
            />
          </svg>
        </div>
      </div>
    </>
  ),
});
